import React from "react";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import { SC_sc_workGroups } from "../../SC/__generated__/SC";
import { Table } from "antd";
import assign from "lodash.assign";
import { Button } from "antd";

const RESEARCHCHANGEWORKGROUPSTATUS = gql`
  mutation RESEARCHCHANGEWORKGROUPSTATUS(
    $sc: ID!
    $group: Int!
    $newStatus: String!
  ) {
    changeWorkGroupStatus(sc: $sc, group: $group, newStatus: $newStatus) {
      sc
    }
  }
`;

interface Props {
  sc: string;
  labs: SC_sc_workGroups[];
  reload: any;
}

export const Research = ({ sc, labs, reload }: Props) => {
  const [changeStatus] = useMutation(RESEARCHCHANGEWORKGROUPSTATUS);

  const handleChangeStatus = async (
    sc: string,
    group: number,
    newStatus: string
  ) => {
    await changeStatus({ variables: { sc, group, newStatus } });
    reload();
  };

  var children: JSX.Element[] = [];

  children.push(<h3 key={"Research"}>Research Operations</h3>);

  const sorted = labs.sort((a, b) => b.group - a.group);

  function formatNumber(num: number) {
    num = Math.floor(num);
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  const labColumns = [
    {
      title: <p style={{ textAlign: "center" }}>Number of Laboratories</p>,
      dataIndex: "number",
      key: "labNumber",
      render: (text: string) => <p style={{ textAlign: "center" }}>{text}</p>
    },
    {
      title: <p style={{ textAlign: "center" }}>TL</p>,
      dataIndex: "tl",
      key: "labTL",
      render: (text: string) => <p style={{ textAlign: "center" }}>{text}</p>
    },
    {
      title: <p style={{ textAlign: "center" }}>Status</p>,
      dataIndex: "status",
      key: "labStatus",
      render: (value: any) => (
        <Button
          block
          onClick={() => handleChangeStatus(sc, value.group, value.nextStatus)}
        >
          {value.status}
        </Button>
      )
    }
  ];

  let labData: any = [];

  sorted.forEach(q => {
    const nextStatus = q.status === "Running" ? "Shut Down" : "Running";

    labData.push(
      assign({
        key: q.group,
        number: formatNumber(q.amount),
        tl: q.tl,
        status: { status: q.status, group: q.group, nextStatus: nextStatus }
      })
    );
  });

  children.push(
    <Table
      key="ResearchTable"
      size="middle"
      dataSource={labData}
      columns={labColumns}
    />
  );

  return <div>{children}</div>;
};
